<!-- Important: Don't remove card-container class from here using that class we are able to handle the horizontal scrolling -->
<section
  class="cards-container focusable-element"
  [ngClass]="'app-cards-' + index"
  [class.now-playing]="nowPlayingId === resource.id"
  [style.width]="sectionWidth"
  [tabindex]="index"
  (focus)="onFocus(resource)"
  (focusout)="focusOut.emit()"
  id="card-identifier"
  [ngStyle]="scrollMovement"
>
  <div class="image-container vertical-ac">
    <div
      class="image-wrapper vertical-as"
      [ngClass]="[
        getClassNames(),
        isPlayerPage || (isDetailPageCards && isEpisodeList)
          ? 'episode-gradient'
          : ''
      ]"
      [style.width]="cardWidth"
      [style.height]="cardHeight"
      [style]="'fontSize.28' | translate"
      [style.--card-width]="cardWidth"
      [style.margin]="isSeries ? '$vh-6 $vw-6' : '$vh-3 $vw-3'"
      [class]="isSeries ? 'card-series' : ''"
    >
      <span class="card-status-label" *ngIf="nowPlayingId === resource.id">
        <span [innerHTML]="'player_now_playing' | translate"></span>
      </span>
      <ng-container *ngIf="!isViewAll; else viewAll">
        <img
          [src]="resource?.image"
          alt="Card Image"
          class="card-image"
          (error)="onImageError($event)"
          loading="lazy"
          (load)="onImageLoad()"
          [class.loaded]="imageLoaded"
        />
        <div *ngIf="!imageLoaded" class="image-placeholder"></div>
        <ng-container *ngIf="showPlayIcon">
          <app-icon [icon]="'play'" class="play-icon"></app-icon>
        </ng-container>
        <div class="progress-bar" *ngIf="isSeries && isProgress">
          <div
            class="progress-bar-fill"
            [style.width]="progressBarWidth + '%'"
          ></div>
        </div>
      </ng-container>
      <ng-template #viewAll>
        <div class="view-all-container vertical-center focusable-container">
          <app-icon
            [icon]="'viewall-arrow-right'"
            class="viewall-icon"
          ></app-icon>
          <h3 class="view-all-title" [style]="'fontSize.28' | translate">
            {{ "view_all_title" | translate }}
          </h3>
        </div>
      </ng-template>
    </div>

    <div class="card-series-content vertical-as" *ngIf="isSeries && !isViewAll">
      <h3 [style]="'fontSize.24' | translate">
        {{ resource?.title[lang] || resource?.title?.en }}
      </h3>
      <h4
        class="card-series-content-info horizontal-as"
        [style]="'fontSize.24' | translate"
      >
        <span>{{ seasonNumber }}</span>
        <span>|</span>
        <span>{{ releaseDate }}</span>
        <span>|</span>
        <span>{{ runningTime }}</span>
      </h4>
      <p [style]="'fontSize.20' | translate">
        {{ resource?.shortDescription[lang] || resource?.shortDescription?.en }}
      </p>
    </div>
  </div>

  <div
    class="progress-bar-outside"
    *ngIf="!isSeries && isProgress && !isViewAll"
  >
    <div
      class="progress-bar-outside-fill"
      [style.width]="progressBarWidth + '%'"
    ></div>
  </div>

  <div
    class="card-title"
    [ngClass]="{ 'player-page': isPlayerPage }"
    *ngIf="!isSeries && isTitleVisible"
  >
    <h3
      [style]="
        isPlayerPage ? ('fontSize.24' | translate) : ('fontSize.20' | translate)
      "
    >
      {{ resource?.title[lang] || resource?.title?.en }}
    </h3>
  </div>
</section>
